"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerIncomeVerificationStatus = void 0;
/**
 * Where an application stands on income verification, as reported to partners.
 *
 * PascalCase values match the `status` field on the same payload. `InProgress` is used rather than
 * `Pending` because `status` already carries a `Pending` value with a different meaning.
 */
var PartnerIncomeVerificationStatus;
(function (PartnerIncomeVerificationStatus) {
    PartnerIncomeVerificationStatus["Verified"] = "Verified";
    PartnerIncomeVerificationStatus["InProgress"] = "InProgress";
    PartnerIncomeVerificationStatus["NotStarted"] = "NotStarted";
})(PartnerIncomeVerificationStatus || (exports.PartnerIncomeVerificationStatus = PartnerIncomeVerificationStatus = {}));
